import React, { useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

export default function ForcePasswordChange() {
  const { user, setUser } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [again, setAgain] = useState("");
  const [busy, setBusy] = useState(false);
  const open = !!user && !!user.must_change_password && !user.impersonating && !user._impersonated_by;

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 6) { toast.error("New password must be at least 6 characters"); return; }
    if (next !== again) { toast.error("The two new passwords don't match"); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      setUser({ ...user, must_change_password: false });
      toast.success("Password updated — you're all set");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not change password");
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={open}>
      <DialogContent className="rounded-none max-w-md border-2 border-[#0F1F2E]" data-testid="force-password-change" onPointerDownOutside={(e) => e.preventDefault()} onEscapeKeyDown={(e) => e.preventDefault()}>
        <div className="text-[10px] font-semibold tracking-[0.24em] uppercase text-[#25AAAA]">Temporary password</div>
        <h2 className="font-display text-2xl font-black tracking-tighter leading-tight">Choose your own password</h2>
        <p className="text-sm text-[#525252]">You signed in with a temporary password set by the programme team. Pick a new one now — only you will know it.</p>
        <form onSubmit={submit} className="space-y-3">
          <Input type="password" placeholder="Temporary password" value={current} onChange={(e) => setCurrent(e.target.value)} required className="rounded-none" data-testid="force-pw-current" />
          <Input type="password" placeholder="New password (min 6 characters)" value={next} onChange={(e) => setNext(e.target.value)} required className="rounded-none" data-testid="force-pw-new" />
          <Input type="password" placeholder="Repeat new password" value={again} onChange={(e) => setAgain(e.target.value)} required className="rounded-none" data-testid="force-pw-again" />
          <Button type="submit" disabled={busy} className="w-full h-11 rounded-none bg-[#25AAAA] hover:bg-[#1e7d7d] uppercase tracking-wide text-xs font-semibold" data-testid="force-pw-submit">
            {busy ? "Saving…" : "Set my password"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
